<template>
  <div>
    <div class="is-flex">
      <label class="is-size-6 is-expanded">{{ label }}</label>
      <label
        class="required-label is-size-7"
        style="margin-top: 4px;"
      >{{ required ? 'required' : 'optonal' }}</label>
    </div>
    <div class="file has-name is-right is-fullwidth">
      <label class="file-label">
        <input
          class="file-input"
          type="file"
          @change="onInputChanged"
          accept="image/jpeg, image/png, application/pdf"
        />
        <span class="file-cta">
          <span class="file-icon">
            <font-awesome-icon icon="upload"></font-awesome-icon>
          </span>
          <span class="file-label" v-show="!uploading">Choose a file…</span>
          <span class="file-label" v-show="uploading">Uploading {{ progress }}%</span>
        </span>
        <span class="file-name">{{ model ? model : 'No Attachment' }}</span>
      </label>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import http from "@/http";
export default {
  props: {
    label: {
      type: String,
      default: "Label"
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      required: true
    },
    valid: {
      default: "unset"
    }
  },
  data() {
    return {
      model: "",
      file: "",
      uploading: false,
      progress: 0
    };
  },
  methods: {
    onInputChanged($event) {
      let component = this;
      let formData = new FormData();
      formData.append("attachment", $event.target.files[0]);
      component.uploading = true;
      component.progress = 0;
      http
        .post("/request/service/attachment/upload", formData, {
          onUploadProgress(progressEvent) {
            component.progress = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }
        })
        .then(response => {
          component.uploading = false;
          component.$emit("input", response.data.filename);
          console.log(response);
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  watch: {
    value() {
      let component = this;
      if (component.type === "date" && moment(component.value).isValid()) {
        component.model = moment(component.value).format("YYYY-MM-DD");
      } else {
        component.model = component.value;
      }
    },
    model() {
      let component = this;
      component.$emit("input", component.model);
    }
  }
};
</script>
<style lang="scss" scoped>
</style>